import styles from "./Settings.module.css";
import { useNavigate } from "react-router-dom";
import {
  Bell,
  ChevronRight,
  CirclePlay,
  Images,
  Lightbulb,
  List,
  LogOut,
  Palette,
  User,
  UserRound,
  Users,
} from "lucide-react";
import { Option } from "../types";

type SettingsOptionsListProps = {
  options: Option[];
  handleClick?: (option: Option) => void;
};

const optionIcons: any = {
  list: List,
  images: Images,
  logIn: UserRound,
  account: User,
  logOut: LogOut,
  palette: Palette,
  bell: Bell,
  circlePlay: CirclePlay,
  lightbulb: Lightbulb,
  users: Users,
};

export default function SettingsOptionsList(props: SettingsOptionsListProps) {
  const navigate = useNavigate();

  return (
    <div className="select-component__duration-section">
      {props.options.map((option, idx) => {
        const Icon = option.iconKey ? optionIcons[option.iconKey] : null;

        return (
          <div key={idx} className={styles.optionRow}>
            <button
              className={`strength-button select-component__duration-button two-part-button ${styles.optionButton} ${styles["option-row"]}`}
              style={{
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
              }}
              onClick={() => {
                if (props.handleClick) {
                  props.handleClick(option);
                  return;
                }
                if (option.link) {
                  navigate(
                    option.link,
                    option.state ? { state: option.state } : undefined
                  );
                }
              }}
            >
              {Icon && (
                <Icon
                  className={`w-4 h-4 text-red-500 ${styles.settingsIconSpacing}`}
                />
              )}
              <span>{option.title}</span>
              <ChevronRight
                className={`w-4 h-4 text-red-500 ${styles.optionIconChevron} ${styles["chevron-right"]}`}
              />
            </button>
          </div>
        );
      })}
    </div>
  );
}
